import { createReducer, on } from '@ngrx/store';
import * as OnboardingActions from './onboarding.actions';
import { HttpActionState } from 'app/main/pages/users/userslisting/store/users-listing.reducers';
import { UserSettings } from 'app/global/user-settings.dto';
import { OnboardingType } from './onboarding.actions';

export interface IUserProfileState {
  firstName: string;
  lastName: string;
  password?: string;
  jobTitle: string;
  companyName?: string;
  phoneNumber: string;
  terms: boolean;
  noMarketing: boolean;
  profileImagePreview: string | null;
  profileImageFile: File | null;
  passwordTextType: boolean;
  submitted: boolean;
}

export interface ITellUsAboutYouState {
  workType: string;
}

// NEW: How Plan To Use State Interface
export interface IHowPlanToUseState {
  planningToUse: string;
}

export interface IOnboardingResponse {
  name: string;
  is_paid: boolean;
}

import { IOnboardingSubmitResponse } from './onboarding.responses.dto';
import { HttpErrorResponse } from '@angular/common/http';

export interface IOnboardingState {
  loading: boolean;
  error: HttpErrorResponse | string | null;
  success: boolean;
  onboardingResponse: IOnboardingSubmitResponse | null;
  userProfile: IUserProfileState;
  tellUsAboutYou: ITellUsAboutYouState;
  howPlanToUse: IHowPlanToUseState;
  onboardingType: OnboardingType;
  profileStepSkipped: boolean; // NEW: Add profileStepSkipped
}

export const initialState: IOnboardingState = {
  loading: false,
  error: null,
  success: false,
  onboardingResponse: null,
  userProfile: {
    firstName: '',
    lastName: '',
    jobTitle: '',
    phoneNumber: '',
    terms: null,
    noMarketing: null,
    profileImagePreview: null,
    profileImageFile: null,
    passwordTextType: false,
    submitted: false,
  },
  tellUsAboutYou: {
    workType: '',
  },
  howPlanToUse: {
    planningToUse: '',
  },
  onboardingType: 'customer',
  profileStepSkipped: false, // NEW: Initialize profileStepSkipped
};

export const onboardingReducers = createReducer(
  initialState,
  on(OnboardingActions.onboardingSubmit, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
    onboardingResponse: null,
  })),
  on(OnboardingActions.onboardingSubmitSucceeded, (state, { response }) => ({
    ...state,
    loading: false,
    error: null,
    success: true,
    onboardingResponse: response,
  })),
  on(OnboardingActions.onboardingSubmitFailed, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
    success: false,
    onboardingResponse: null,
  })),
  on(OnboardingActions.resetOnboardingState, () => ({
    ...initialState,
  })),
  on(OnboardingActions.updateUserProfileField, (state, { field, value }) => ({
    ...state,
    userProfile: {
      ...state.userProfile,
      [field]: value,
    },
  })),
  on(OnboardingActions.updateProfileImage, (state, { profileImage }) => ({
    ...state,
    userProfile: {
      ...state.userProfile,
      profileImagePreview: profileImage,
    },
  })),
  on(OnboardingActions.setProfileImageFile, (state, { profileImageFile }) => ({
    ...state,
    userProfile: {
      ...state.userProfile,
      profileImageFile: profileImageFile,
    },
  })),
  on(OnboardingActions.togglePasswordTextType, (state) => ({
    ...state,
    userProfile: {
      ...state.userProfile,
      passwordTextType: !state.userProfile.passwordTextType,
    },
  })),
  on(OnboardingActions.setUserProfileFormSubmitted, (state, { submitted }) => ({
    ...state,
    userProfile: {
      ...state.userProfile,
      submitted: submitted,
    },
  })),
  on(OnboardingActions.updateTellUsAboutYouWorkType, (state, { workType }) => ({
    ...state,
    tellUsAboutYou: {
      ...state.tellUsAboutYou,
      workType: workType,
    },
  })),

  on(OnboardingActions.updateHowPlanToUsePlanningToUse, (state, { planningToUse }) => ({
    ...state,
    howPlanToUse: {
      ...state.howPlanToUse,
      planningToUse: planningToUse,
    },
  })),
  on(OnboardingActions.setOnboardingType, (state, { onboardingType }) => ({
    ...state,
    onboardingType: onboardingType,
  })),

  on(OnboardingActions.checkToken, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),

  on(OnboardingActions.checkTokenSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    success: true,
  })),

  on(OnboardingActions.checkTokenFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
    success: false,
  })),
  on(OnboardingActions.setProfileStepSkipped, (state, { skipped }) => ({
    ...state,
    profileStepSkipped: skipped,
  })),
  on(OnboardingActions.updateError, (state, { error }) => ({
    ...state,
    error: error,
  }))
);